import { FC } from 'react';

interface AlertProps {
  children: React.ReactNode;
  status?: 'error' | 'success';
}

const Alert: FC<AlertProps> = ({ children, status = 'error' }) => {
  const bgColor = status === 'error' ? 'bg-red-50' : 'bg-green-50';
  const textColor = status === 'error' ? 'text-red-700' : 'text-green-700';

  return (
    <div className={`p-4 rounded-md ${bgColor}`}>
      <p className={`text-sm ${textColor}`}>{children}</p>
    </div>
  );
};

export default Alert;
